'use client';

import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { isUserOnWaitlist, isWaitlistedListing } from '@/src/components/features/property/lib/waitlist';
import { getScheduledTour } from '@/src/components/features/property/TourForm/tourUtils';
import { useCurrentUser } from '@/src/lib/hooks/query';
import { useScheduledToursForUser } from '@/src/lib/hooks/query/useHpToursQuery';
import { hasBookableTourProvider } from '@/src/lib/utils/instantTourProviders';

export const useListingCTAAvailability = (listing: PropertyDetailListing | null | undefined) => {
  const { data: currentUser } = useCurrentUser();
  const scheduledToursQuery = useScheduledToursForUser(currentUser?.loggedIn ?? false);
  const active = Boolean(listing && listing.active !== false);
  const contact = active && !(isWaitlistedListing(listing) && isUserOnWaitlist(listing));
  const hasScheduledTour = Boolean(getScheduledTour(listing?.aliasEncoded, scheduledToursQuery.data));
  const tour = active && hasBookableTourProvider(listing?.details?.instantTourProviders) && !hasScheduledTour;
  const apply = active && listing?.rentalApplicationStatus?.toLowerCase() === 'accepted';

  return {
    contact,
    tour,
    // Exposed because "no tour CTA" has two very different causes, and a caller that has to
    // explain itself (`book_tour`) needs to tell them apart.
    hasScheduledTour,
    apply,
    hasCTAs: contact || tour || apply,
    toursReady: currentUser?.loggedIn !== true || scheduledToursQuery.isSuccess,
  };
};
